(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-geo-pixel-icon]');
  if (!roots.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canvasResize = window.EastDtcCanvasResize;

  var PALETTE = {
    '.': null,
    b: '#4da3ff',
    B: '#7ec8ff',
    r: '#e60012',
    R: '#ff4d6a',
    w: '#ffffff',
    g: 'rgba(255,255,255,0.35)',
    d: '#0c1830'
  };

  /* 20×20 像素画，双帧动画 */
  var ICONS = {
    'shopify-global': {
      frames: [
        [
          '....................',
          '....................',
          '......bbbb..........',
          '.....bbbbbb.........',
          '....bbbbbbbb........',
          '...bbbb..bbbb.......',
          '...bbb....bbb.......',
          '..bbb......bbb......',
          '..bb........bb......',
          '.bbb........bbb.....',
          '.bbb...rr...bbb.....',
          '..bb...rr...bb......',
          '..bbb..rr..bbb......',
          '...bbbbrrbbbb.......',
          '....bbbbbbbb........',
          '.....bbbbbb.........',
          '......bbbb..........',
          '....................',
          '....................',
          '....................'
        ],
        [
          '....................',
          '....................',
          '......bbbb..........',
          '.....bbbbbb.........',
          '....bbbbbbbb........',
          '...bbbb..bbbb.......',
          '...bbb....bbb.......',
          '..bbb......bbb......',
          '..bb........bb......',
          '.bbb....rr..bbb.....',
          '.bbb....rr..bbb.....',
          '..bb....rr..bb......',
          '..bbb...rr..bbb.....',
          '...bbbb.rr.bbbb.....',
          '....bbbbbbbb........',
          '.....bbbbbb.........',
          '......bbbb..........',
          '....................',
          '....................',
          '....................'
        ]
      ]
    },
    'ai-discovery': {
      frames: [
        [
          '....................',
          '......bbbbbb........',
          '.....bbbbbbbb.......',
          '....bbbbbbbbbb......',
          '....bbb....bbb......',
          '....bbb....bbb......',
          '....bbbbbbbbbb......',
          '.....bbbbbbbb.......',
          '......bbbbbb........',
          '.......bbbb.........',
          '......bbbbbb........',
          '.....bbbbbbbb.......',
          '....bbb....bbb......',
          '....bbb....bbb......',
          '....bbb....bbb......',
          '.....bb....bb.......',
          '.....bb....bb.......',
          '.....bbb..bbb.......',
          '.....bbb..bbb.......',
          '....................'
        ],
        [
          '....................',
          '......bbbbbb........',
          '.....bbbbbbbb.......',
          '....bbbbbbbbbb......',
          '....bbb....bbb......',
          '....bbb....bbb......',
          '....bbbbbbbbbb......',
          '.....bbbbbbbb.......',
          '......bbbbbb........',
          '.......bbbb.........',
          '......bbbbbb........',
          '.....bbbbbbbb.......',
          '....bbb....bbb......',
          '....bbb....bbb......',
          '....bbb....bbb......',
          '.....bb....bb.......',
          '.....bb....bb.......',
          '.....bbbbbbbb.......',
          '.....bbbbbbbb.......',
          '....................'
        ]
      ],
      overlay: function (ctx, cell, ox, oy, t) {
        var blink = Math.floor(t * 3) % 2 === 0;
        if (!blink) return;
        paintCell(ctx, ox + 8 * cell, oy + 12 * cell, cell, PALETTE.r);
        paintCell(ctx, ox + 9 * cell, oy + 12 * cell, cell, PALETTE.r);
        paintCell(ctx, ox + 10 * cell, oy + 12 * cell, cell, PALETTE.r);
        paintCell(ctx, ox + 11 * cell, oy + 12 * cell, cell, PALETTE.r);
      }
    },
    'social-aeo': {
      frames: [
        [
          '....................',
          '...dddddddddddd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dddddddddddd.....',
          '....................',
          '....................',
          '....................',
          '....................',
          '....................',
          '....................',
          '....................',
          '....................'
        ],
        [
          '....................',
          '...dddddddddddd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dwwwwwwwwwwd.....',
          '...dddddddddddd.....',
          '....................',
          '....................',
          '....................',
          '....................',
          '....................',
          '....................',
          '....................',
          '....................'
        ]
      ],
      overlay: function (ctx, cell, ox, oy, t) {
        var bars = [
          { x: 5, h: 2, c: PALETTE.b },
          { x: 7, h: 4, c: PALETTE.b },
          { x: 9, h: 3, c: PALETTE.B },
          { x: 11, h: 5, c: PALETTE.r },
          { x: 13, h: 3, c: PALETTE.b }
        ];
        var baseY = 9;
        var pulse = 0.85 + 0.15 * Math.sin(t * 4);
        bars.forEach(function (bar, i) {
          var h = Math.max(1, Math.round(bar.h * pulse + Math.sin(t * 3 + i) * 0.35));
          for (var row = 0; row < h; row++) {
            paintCell(ctx, ox + bar.x * cell, oy + (baseY - row) * cell, cell, bar.c);
          }
        });
        var lx = 5 + Math.floor((t * 2) % 8);
        paintCell(ctx, ox + lx * cell, oy + 5 * cell, cell, PALETTE.w);
        paintCell(ctx, ox + (lx + 1) * cell, oy + 4 * cell, cell, PALETTE.B);
        paintCell(ctx, ox + (lx + 2) * cell, oy + 3 * cell, cell, PALETTE.b);
      }
    },
    'content-entity': {
      frames: [
        [
          '....................',
          '......bbbbbb........',
          '.....bbbbbbbb.......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '.....bbbbbbbb.......',
          '......bbbbbb........',
          '.......bbbb.........',
          '........bb..........',
          '....................',
          '....................',
          '....................'
        ],
        [
          '....................',
          '......bbbbbb........',
          '.....bbbbbbbb.......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '....bbbbbbbbbb......',
          '.....bbbbbbbb.......',
          '......bbbbbb........',
          '.......bbbb.........',
          '........bb..........',
          '....................',
          '....................',
          '....................'
        ]
      ],
      overlay: function (ctx, cell, ox, oy, t) {
        var scan = Math.floor((t * 5) % 12);
        for (var i = 0; i < 3; i++) {
          paintCell(ctx, ox + (6 + i) * cell, oy + (6 + scan) * cell, cell, PALETTE.g);
        }
        paintCell(ctx, ox + 6 * cell, oy + 14 * cell, cell, PALETTE.r);
        paintCell(ctx, ox + 7 * cell, oy + 14 * cell, cell, PALETTE.r);
        paintCell(ctx, ox + 10 * cell, oy + 14 * cell, cell, PALETTE.b);
        paintCell(ctx, ox + 11 * cell, oy + 14 * cell, cell, PALETTE.b);
      }
    }
  };

  function paintCell(ctx, x, y, size, color) {
    if (!color) return;
    ctx.fillStyle = color;
    ctx.fillRect(Math.round(x), Math.round(y), Math.ceil(size), Math.ceil(size));
  }

  function drawGrid(ctx, grid, cell, ox, oy) {
    for (var y = 0; y < grid.length; y++) {
      var row = grid[y];
      for (var x = 0; x < row.length; x++) {
        var key = row.charAt(x);
        var color = PALETTE[key];
        if (color) {
          paintCell(ctx, ox + x * cell, oy + y * cell, cell, color);
        }
      }
    }
  }

  function drawIcon(ctx, id, w, h, t) {
    var spec = ICONS[id] || ICONS['ai-discovery'];
    var frames = spec.frames;
    var frameIndex = prefersReducedMotion ? 0 : Math.floor(t * 2.5) % frames.length;
    var grid = frames[frameIndex];

    var gridSize = grid.length;
    var cell = Math.floor(Math.min(w, h) / gridSize);
    var ox = (w - cell * gridSize) / 2;
    var oy = (h - cell * gridSize) / 2;

    ctx.clearRect(0, 0, w, h);

    var glow = 0.35 + 0.2 * Math.sin(t * 2);
    ctx.shadowColor = 'rgba(77, 163, 255, 0.65)';
    ctx.shadowBlur = 8 + glow * 6;

    drawGrid(ctx, grid, cell, ox, oy);

    ctx.shadowBlur = 0;

    if (spec.overlay && !prefersReducedMotion) {
      spec.overlay(ctx, cell, ox, oy, t);
    }
  }

  function initRoot(root) {
    var canvas = root.querySelector('.geo-pixel-icon__canvas');
    if (!canvas) return;

    var id = root.getAttribute('data-geo-pixel-icon') || 'ai-discovery';
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cssSize = 120;
    var running = false;
    var rafId = null;
    var start = performance.now();

    function resize() {
      var measured = 120;
      if (canvasResize) {
        measured = canvasResize.measureCanvasSize(canvas, root, {
          minWidth: 80,
          minHeight: 80,
          fallbackViewportWidth: false
        }).width;
      } else {
        measured = canvas.clientWidth || root.getBoundingClientRect().width || root.offsetWidth || 120;
      }
      cssSize = Math.max(80, Math.min(140, measured));
      if (canvasResize) {
        canvasResize.applyCanvasDisplaySize(canvas);
      } else {
        canvas.style.width = '100%';
        canvas.style.height = '100%';
      }
      canvas.width = Math.round(cssSize * dpr);
      canvas.height = Math.round(cssSize * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function resizeIfNeeded() {
      if (canvasResize && !canvasResize.canvasNeedsResize(canvas, cssSize, cssSize, dpr)) {
        return false;
      }
      var prev = cssSize;
      resize();
      return prev !== cssSize;
    }

    function frame(now) {
      if (!running) return;
      resizeIfNeeded();
      var t = (now - start) / 1000;
      drawIcon(ctx, id, cssSize, cssSize, t);
      rafId = requestAnimationFrame(frame);
    }

    function startLoop() {
      if (running) return;
      running = true;
      resize();
      rafId = requestAnimationFrame(frame);
    }

    function stopLoop() {
      running = false;
      if (rafId) cancelAnimationFrame(rafId);
    }

    resize();

    if (prefersReducedMotion) {
      drawIcon(ctx, id, cssSize, cssSize, 0);
    } else {
      startLoop();
    }

    function onLayoutSync(fromTabVisible) {
      resize();
      if (prefersReducedMotion) {
        drawIcon(ctx, id, cssSize, cssSize, 0);
      } else if (fromTabVisible) {
        startLoop();
      }
    }

    var tabLayout = canvasResize ? canvasResize.createLayoutScheduler(onLayoutSync) : null;

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        if (document.hidden) return;
        if (tabLayout) tabLayout.schedule();
        else onLayoutSync(false);
      });
      ro.observe(root);
    }

    if (tabLayout) {
      tabLayout.bindLifecycle({
        onHidden: function () {
          if (!prefersReducedMotion) stopLoop();
        },
        onVisible: function () {
          if (prefersReducedMotion) tabLayout.syncWhenVisible();
          else {
            stopLoop();
            tabLayout.syncWhenVisible();
          }
        }
      });
    } else {
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopLoop();
        else if (!prefersReducedMotion) startLoop();
      });
    }
  }

  roots.forEach(initRoot);
})();
